import { DefaultPaymentSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/PaymentSortFilterType";
import { type FilterValues } from "components/filters/FilterContext";
import { mapBookkeepingFilterToInstruction, mapCompanyFilterToInstruction, mapKeywordFilterToInstruction, mapPaymentMethodFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToBookkeepingFilter, mapResponseToCompanyFilter, mapResponseToKeywordFilter, mapResponseToPaymentMethodFilter, mapResponseToPeriodFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedPaymentInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    companyIds: mapCompanyFilterToInstruction(filter.company),
    paymentMethods: mapPaymentMethodFilterToInstruction(filter.paymentMethod),
    bookkeepingIds: mapBookkeepingFilterToInstruction(filter.bookkeepings),
    period: mapPeriodFilterToInstruction(filter.period),
    order: filter.paymentSort.sortOption.value,
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListPaymentFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  company: mapResponseToCompanyFilter(response.companies),
  paymentMethod: mapResponseToPaymentMethodFilter(response.paymentMethods),
  bookkeepings: mapResponseToBookkeepingFilter(response.bookkeepings),
  period: mapResponseToPeriodFilter(response.period),
  // TODO: This can be done better
  paymentSort: {
    sortOption: (response.order !== "receivedOnDesc")
      ? getSortOption(response.order)
      : getSortOption(DefaultPaymentSortFilter)
  }
});